// src/instrument.ts
import * as Sentry from '@sentry/react';
import { shouldIgnoreSentryEvent } from './lib/sentry';

Sentry.init({
  dsn: "https://8e4f4227a34a1848ef32f87ebcc87345@o4510213633277952.ingest.us.sentry.io/4510213716770816",
  
  // Adds request headers and IP for users
  sendDefaultPii: true,

  integrations: [
    // Performance monitoring
    Sentry.browserTracingIntegration(),
    // Session Replay
    Sentry.replayIntegration(),
    // User Feedback (optional)
    Sentry.feedbackIntegration({
      colorScheme: "system",
    }),
    // send console.log, console.warn, and console.error calls as logs to Sentry
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
  ],
  
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of transactions
  tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],
  
  // Session Replay
  replaysSessionSampleRate: 0.1, // 10% of sessions
  replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors
  
  // Enable logs (optional)
  enableLogs: true,

  // Drop unresolvable iOS WebKit stack-overflow noise while keeping real recursions
  beforeSend(event) {
    return shouldIgnoreSentryEvent(event) ? null : event;
  },
});